import { z } from "zod"

import { SalesPipelineSortField, SalesPipelineStatusGql, SortingOrder } from "@/graphql/codegen/graphql"

export const salesOpportunitySearchSchema = z.object({
  query: z.string().optional(),
  field: z.nativeEnum(SalesPipelineSortField).optional(),
  order: z.nativeEnum(SortingOrder).optional(),
  companyIds: z.array(z.string()).optional(),
  createdByUserIds: z.array(z.string()).optional(),
  statuses: z.array(z.nativeEnum(SalesPipelineStatusGql)).optional(),
  // ISO date strings; passed to BE as `quoteDateRange: { start, end? }` in the store.
  quoteDateFrom: z.string().optional(),
  quoteDateTo: z.string().optional(),
})

export type SalesOpportunitySearchParams = z.infer<typeof salesOpportunitySearchSchema>
